module.exports = __webpack_public_path__ + "static/media/Resume_Satya.2711ca76.pdf";